import React, { useState, useCallback, useEffect, useRef } from 'react';
import DataGrid, {
  ColumnFixing,
  Export,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Scrolling,
  SearchPanel,
  Selection,
  FilterPanel,
  Sorting,
  FilterRow
} from 'devextreme-react/data-grid';
import { StateStoring } from 'devextreme-react/pivot-grid';
import { formatMessage } from 'devextreme/localization';
import { replaceString } from '../../utils/functions';
import styles from './simpledatagrid.module.scss';

const SimpleDataGrid = ({
  children,
  setStateStoringName,
  dataSource,
  onSelectionChanged,
  onCellPrepared,
  onInitialized,
  className,
  onSearchChanged = () => {},
  onCellClick,
  visibleFilter = true,
  onRowUpdated,
  enableHeaderFilter = false,
  enableExport = false,
  dataGridOnOptionChanged,
  visibleButtonAddButton = '',
  visibleGroupPanel = true,
  visibleButtonCheckAll = false,
  keyExpr = 'pieceNumId',
  isDataLoading,

  scrollingMode = 'virtual',

  selectionMode = 'multiple',
  selectedRowKeys,
  visibleSearchPanel = true,
  focusedRowEnabled,
  onFilterChanged = () => {},
  focusedRowIndex,
  onFocusedRowChanged,
  visibleFilterPanel = true
}) => {
  const [combinedFilter, setCombinedFilter] = useState(null);
  const ref = useRef(null);

  const onContentReady = useCallback(
    (e) => {
      if (
        combinedFilter !== null
        && JSON.stringify(combinedFilter)
          !== JSON.stringify(e.component.getCombinedFilter())
      ) {
        onFilterChanged();
        setCombinedFilter(e.component.getCombinedFilter());
      } else {
        setCombinedFilter(e.component.getCombinedFilter());
      }
    },
    [combinedFilter, onFilterChanged]
  );

  // Инициализация компонентом загрузки
  useEffect(() => {
    if (
      typeof isDataLoading !== 'undefined'
      && Object.keys(ref.current).length
    ) {
      if (isDataLoading) {
        ref.current.instance.beginCustomLoading();
      } else {
        ref.current.instance.endCustomLoading();
      }
    }
  }, [isDataLoading]);

  const onOptionChanged = useCallback(
    ({ value, name, fullName }) => {
      if (dataGridOnOptionChanged && name === 'searchPanel') {
        if ((value && value.length >= 3) || value === null || value === '') {
          setTimeout(() => {
            ref.current.instance.searchByText(replaceString(value));
            dataGridOnOptionChanged({
              value: replaceString(value),
              name
            });
          }, 200);
        }
      }
      if (fullName === 'searchPanel.text') {
        onSearchChanged();
      }
    },
    [dataGridOnOptionChanged, onSearchChanged]
  );

  const onToolbarPreparing = useCallback(
    (toolbar) => {
      // const removed = toolbar.toolbarOptions.items.splice(
      //   visibleGroupPanel ? 3 : 2
      // );
      // toolbar.toolbarOptions.items.splice(
      //   visibleGroupPanel ? 1 : 0,
      //   0,
      //   removed[0]
      // );
      if (visibleButtonAddButton) {
        toolbar.toolbarOptions.items.push({
          location: 'before',
          template: visibleButtonAddButton
        });
      }
    },
    [visibleButtonAddButton]
  );

  return (
    <div className={styles.containing}>
      <div className={styles.main}>
        <DataGrid
          ref={ref}
          dataSource={dataSource}
          elementAttr={{
            class: `${styles.dataGrid} ${className} ${!visibleButtonCheckAll
              && styles.buttonCheckAll}`
          }}
          showBorders
          onInitialized={onInitialized}
          hoverStateEnabled
          columnAutoWidth
          allowColumnResizing
          rowAlternationEnabled
          onSelectionChanged={onSelectionChanged}
          onOptionChanged={onOptionChanged}
          onRowUpdated={onRowUpdated}
          onCellPrepared={onCellPrepared}
          onCellClick={onCellClick}
          onFocusedRowChanged={onFocusedRowChanged}
          // onContextMenuPreparing={addHeaderSumButtonMenu}
          onContentReady={onContentReady}
          keyExpr={keyExpr}
          twoWayBindingEnabled={false}
          columnResizingMode="widget"
          cacheEnabled
          selectedRowKeys={selectedRowKeys}
          focusedRowEnabled={focusedRowEnabled}
          focusedRowIndex={focusedRowIndex}
          onToolbarPreparing={onToolbarPreparing}
        >
          <FilterPanel visible={visibleFilterPanel} />
          <FilterRow visible={visibleFilter} />
          <StateStoring
            enabled={!!setStateStoringName}
            type="localStorage"
            storageKey={setStateStoringName}
          />
          <Selection
            mode={selectionMode}
            allowSelectAll={false}
            selectAllMode="allPages"
            showCheckBoxesMode="always"
          />
          <Sorting mode="multiple" />
          {/* <ColumnChooser enabled /> */}
          <ColumnFixing enabled />
          <Export
            enabled={enableExport}
            fileName="Export"
            texts={{ exportAll: formatMessage('textDataGrid').exportExcel }}
            allowExportSelectedData
          />
          <HeaderFilter visible={enableHeaderFilter} />
          <Grouping autoExpandAll={false} />
          <GroupPanel visible={visibleGroupPanel} />
          <Scrolling mode={scrollingMode} />
          <SearchPanel
            visible
            width={240}
            onValueChanged={onSearchChanged}
            placeholder={`${formatMessage('textDataGrid').textSearch}...`}
          />
          {children}
        </DataGrid>
      </div>
    </div>
  );
};

export default React.memo(SimpleDataGrid);
